/** Client import недоступен в браузере — onClick/action нужно выполнить на middle. */
export class MiddleExecutionRequiredError extends Error {
  readonly importName: string

  constructor(importName: string) {
    super(`Client import "${importName}" requires middle execution`)
    this.name = 'MiddleExecutionRequiredError'
    this.importName = importName
  }
}
